export enum ReviewItemType {
  Session = 'EfacitySession',
  Product = 'Product',
  Educator = 'EfacityUser'
}
